import { http } from '@/app/lib/http/client'

export interface InventoryItem {
  id: number
  name: string
  category: string
  stock: number
  stockCentro: number
  stockNorte: number
  stockSur: number
  minStock: number
  price: number
  cost: number
  branch: string
  lot: string
  expiry: string
  lastMovement: string
  supplier: string
  image?: string
}

export interface PendingTransfer {
  id: string
  date: string
  fromBranch: string
  toBranch: string
  products: Array<{
    name: string
    quantity: number
  }>
  status: 'pending' | 'completed'
}

export const taxService = {
  async getTaxes(params?: Record<string, unknown>) {
    const response = await http.get('/taxes', { params })
    return response.data
  },
}

export const inventoryService = {
  /**
   * Obtiene la lista de productos paginada
   */
  async getProducts(page: number = 1) {
    const response = await http.get('/products', {
      params: { page }
    })
    return response.data
  },

  /**
   * Importa productos desde un archivo Excel
   * @param file Archivo Excel a importar (.xls, .xlsx)
   * @param sucursalId ID de la sucursal actual
   * @param mode Modo de importación (upsert por defecto)
   * @param chunkSize Cantidad de registros por chunk (200 por defecto)
   */
  async importProducts(
    file: File,
    sucursalId: number,
    mode: 'upsert' = 'upsert',
    chunkSize: number = 200
  ) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('sucursal_id', sucursalId.toString())
    formData.append('mode', mode)
    formData.append('chunk_size', chunkSize.toString())

    const response = await http.post('/products/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },
}